import React from 'react';
import { toast } from 'react-toastify';

const CustomDndModal = ({
    showCustomDndModal,
    setShowCustomDndModal,
    customDndDate,
    setCustomDndDate,
    customDndTime,
    setCustomDndTime,
    setCurrentStatus,
    formatDisplayDate,
    formatDisplayTime,
    dndBypassRules,
    getAuthHeaders = { getAuthHeaders }
}) => {
    if (!showCustomDndModal) return null;

    return (
        <div
            className="status-modal-overlay"
            onClick={() => setShowCustomDndModal(false)}
        >
            <div className="status-modal" onClick={(e) => e.stopPropagation()}>
                <div className="status-modal-header">
                    <h2>Specific Duration</h2>

                    <button
                        type="button"
                        className="status-close-btn"
                        onClick={() => setShowCustomDndModal(false)}
                    >
                        ✕
                    </button>
                </div>

                <label className="specific-duration-field">
                    End date
                    <input
                        type="date"
                        className="status-input"
                        value={customDndDate}
                        onChange={(e) => setCustomDndDate(e.target.value)}
                    />
                </label>

                <label className="specific-duration-field">
                    End time
                    <input
                        type="time"
                        className="status-input"
                        value={customDndTime}
                        onChange={(e) => setCustomDndTime(e.target.value)}
                    />
                </label>

                <div className="status-modal-actions">
                    <button
                        type="button"
                        className="status-cancel-btn"
                        onClick={() => setShowCustomDndModal(false)}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="status-save-btn"
                        onClick={async () => {
                            try {
                                const expiresAt = new Date(
                                    `${customDndDate}T${customDndTime}`
                                ).toISOString();

                                const payload = {
                                    type: 'dnd',
                                    enabled: true,
                                    label: 'Specific Duration',
                                    text: 'Do Not Disturb',
                                    source: 'specific_duration',
                                    expiresAt,
                                    bypassRules: dndBypassRules,
                                };

                                const res = await fetch('/api/availability', {
                                    method: 'POST',
                                    headers: {
                                        ...getAuthHeaders(),
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(payload),
                                });

                                if (!res.ok) {
                                    throw new Error('Failed to save DND');
                                }

                                const savedStatus = await res.json();

                                const newStatus = {
                                    id: savedStatus._id,
                                    type: 'dnd',
                                    text: 'Do Not Disturb',
                                    duration: 'Specific Duration',
                                    untilTime: `${formatDisplayDate(customDndDate)} at ${formatDisplayTime(customDndTime)}`,
                                    expiresAt: savedStatus.expiresAt,
                                    bypassRules: savedStatus.bypassRules,
                                };

                                setCurrentStatus(newStatus);

                                localStorage.setItem(
                                    'kuddlecore_active_status',
                                    JSON.stringify(newStatus)
                                );

                                window.dispatchEvent(
                                    new Event('kuddle:availability-updated')
                                );

                                setShowCustomDndModal(false);


                            } catch (err) {
                                console.error(err);
                                toast.error('Unable to save');
                            }
                        }}
                    >
                        Save DND
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomDndModal;